<template>
  <span class="tooltip" :class="classes" :style="style">
    <slot :active="active" />
  </span>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    direction: {
      type: String,
      default: 'bottom'
    },
    color: {
      type: String,
      default: '#233447'
    }
  },
  data: () => ({
    active: false,
    parentClass: null,
    topPosition: false,
    leftPosition: false,
    isTooltipFullScreenWidth: false,
  }),
  mounted(){
    this.tooltipElement = this.$el
    this.parentElement = this.tooltipElement.parentNode

    this.parentElement.addEventListener('mouseenter', this.open)
    this.parentElement.addEventListener('focus', this.open)
    this.parentElement.addEventListener('mouseleave', this.close)
    this.parentElement.addEventListener('blur', this.close)
  },
  beforeDestroy() {
    this.active = false

    this.removeTooltips()

    this.parentElement.removeEventListener('mouseenter', this.open)
    this.parentElement.removeEventListener('focus', this.open)
    this.parentElement.removeEventListener('mouseleave', this.close)
    this.parentElement.removeEventListener('blur', this.close)
  },
  watch: {
    direction() {
      this.calculateTooltipPosition()
    }
  },
  computed: {
    classes() {
      const cssClasses = {
        'active': this.active,
        'tooltip-top': this.direction === 'top',
        'tooltip-right': this.direction === 'right',
        'tooltip-bottom': this.direction === 'bottom',
        'tooltip-left': this.direction === 'left',
        'tooltip-full': this.isTooltipFullScreenWidth
      }
      return cssClasses
    },
    style() {
      return {
        backgroundColor: this.color,
        top: this.topPosition + 'px',
        left: this.leftPosition + 'px'
      };
    }
  },
  methods: {
    removeTooltips() {
      if(this.tooltipElement.parentNode){
        this.tooltipElement.parentNode.removeChild(this.tooltipElement)
      }
    },
    async calculateTooltipPosition() {

      // make sure calculations are done assuming it's not a full-width tooltip
      this.isTooltipFullScreenWidth = false
      await this.$nextTick()

      const position = this.parentElement.getBoundingClientRect()
      const tooltipbounds = this.tooltipElement.getBoundingClientRect()

      // minimum and maximum left position to avoid having the tooltip off-screen
      const minimumLeftPosition = tooltipbounds.width/2 + 20
      const maximumLeftPosition = window.innerWidth - tooltipbounds.width/2 - 20

      // calculate whether the tooltip should be full width
      this.isTooltipFullScreenWidth = window.innerWidth - tooltipbounds.width - 40 <= 0

      let top = 0
      let left = 0
      if(this.direction == 'top'){
        top = position.top - this.$el.offsetHeight
        left = position.left + position.width / 2
      }
      else if(this.direction == 'right'){
        top = position.top
        left = position.left + position.width
      }
      else if(this.direction == 'bottom'){
        top = position.bottom
        left = position.left  + position.width / 2
      }
      else if(this.direction == 'left'){
        top = position.top
        left = position.left - this.$el.offsetWidth
      }
      else{
        console.warn(`Invalid direction option: ${this.direction}`);
      }

      this.topPosition = top
      this.leftPosition = Math.max(minimumLeftPosition, Math.min(maximumLeftPosition, left))
    },
    open(){
      this.removeTooltips()

      // No content in tooltip, don't append
      if(this.tooltipElement.childNodes.length === 0){
        return
      }

      document.body.appendChild(this.tooltipElement)
      getComputedStyle(this.tooltipElement).top
      this.active = true

      this.calculateTooltipPosition()
    },
    close() {
      this.active = false
      this.removeTooltips()
    }
  }
}
</script>